import React, { useState } from "react";
import { PUBLISH_TO_GMB_STEPS } from "./constant";
import GoogleMyBusinessAuth from "./GoogleMyBusinessAuth";
import GoogleMyBusinessAuthError from "./GoogleMyBusinessAuthError";
import PublishToGMBForm from "./publish-to-gmb-form";
export const PublishToGMBSteps = ({ spaceId, onPublishToGMBSuccess, spaceType, staged, }) => {
    const [publishToGMBStep, setPublishToGMBStep] = useState(PUBLISH_TO_GMB_STEPS.GMB_AUTH);
    switch (publishToGMBStep) {
        case PUBLISH_TO_GMB_STEPS.GMB_AUTH:
            return React.createElement(GoogleMyBusinessAuth, { setPublishToGMBStep: setPublishToGMBStep });
        case PUBLISH_TO_GMB_STEPS.PROPERTY_SELECTION:
            return (React.createElement(PublishToGMBForm, { staged: staged, spaceId: spaceId, spaceType: spaceType, onPublishToGMBSuccess: onPublishToGMBSuccess }));
        case PUBLISH_TO_GMB_STEPS.GMB_ERROR:
            return React.createElement(GoogleMyBusinessAuthError, null);
        default:
            return null;
    }
};
export default PublishToGMBSteps;
